export default "<p>You do not have the access to this resource. Please contact the site administrator.</p>\n"